import api, { request } from '../../../api';

import { ISeasonAwardsStore } from './store';

import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';

export type TGetSeasonAwardsAction = (
  seasonId: number,
  force?: boolean
) => { seasonAwards?: ISeasonAwardsStore; errors?: IErrorsStore };

export interface ISeasonAwardsActions extends IActionGroup {
  get: TGetSeasonAwardsAction;
}

const actions: IActionGroup = {
  get: async (state: IStore, seasonId: number) => {
    if (state.seasonAwards[seasonId]) {
      return {
        seasonAwards: state.seasonAwards
      };
    }

    const response = await request.get(api.seasonAwards('player', seasonId));

    if (response.error) {
      return { errors: { seasonAwards: { msg: 'Error retrieving the Season Awards' } } };
    }

    return {
      seasonAwards: {
        [seasonId]: groupBy(response, 'userId')
      }
    };
  }
};

export default actions;
